import { ArrowBackIosOutlined } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import logo from '../../assets/img/logoSmall.png';
import React from 'react';
import { NavLink } from 'react-router-dom';
import themes from 'styles/themes';
const useStyles = makeStyles({
    header: {
        '@media (max-width: 1024px)': {
            position: 'fixed',
        },
        textAlign: 'center',
        padding: '10px 24px',
        position: 'absolute',
        display: 'flex',
        zIndex: 100,
        left: 0,
        right: 0,
        background: themes.palette.primary.light,
        top: 0,
        width: '100%',
        alignItems: 'center',
    },
});

function HeaderBack(props) {
    const classes = useStyles();
    return (
        <div className={classes.header}>
            {props.isBack && (
                <NavLink to={`${props.backTo}`}>
                    <ArrowBackIosOutlined style={{ color: themes.palette.common.white }} />
                </NavLink>
            )}
            {props.isLogo ? (
                <div
                    style={{
                        margin: 0,
                        flex: 1,
                        paddingRight: `${props.isBack ? 24 : 0}px`,
                    }}
                >
                    <img src={logo} style={{ width: '45px' }} alt="logo" />
                </div>
            ) : (
                <span
                    style={{
                        fontSize: 24,
                        fontWeight: 400,
                        margin: 0,
                        fontFamily: 'Fraunces_120pt_SuperSoft_Wonky-Medium',
                        color: themes.palette.primary.main,
                        flex: 1,
                        paddingRight: `${props.isBack ? 24 : 0}px`,
                    }}
                >
                    {props.title}
                </span>
            )}
        </div>
    );
}

export default HeaderBack;
